<div class="td-wb-notification-toast"
  [class.td-wb-notification-toast__bk-red]="toast().isRejected"
  role="alert">
  <div class="td-wb-notification-toast__content">
    @if (!isExcessMessage()) {
      <div class="td-wb-notification-toast__status">
        <td-wb-icon class="td-wb-notification-toast__icon" [iconId]="toast().isRejected ? 'error' : 'approved' " size="24" />
      </div>
      <ng-container *ngTemplateOutlet="newMLONotificationEnabled ? orderTemplate : oldOrderTemplate" />
    } @else {
      <div class="td-wb-notification-toast__full">
        <div>
          <span translate="tdWb.orderNotificationsToast.EXCESS_MESSAGE_PRE"></span>
          <span [innerText]="excessMessageCount()"></span>
          <span translate="tdWb.orderNotificationsToast.EXCESS_MESSAGE_POST"></span>
        </div>
        <div>
          <a class="td-wb-link" tdWbHref="link_order_status" [tdWbHrefParams]="{ clearAllFilters: true }" options="{reload: true}">
            <span translate="tdWb.orderNotificationsToast.ORDER_STATUS"></span>
          </a>
        </div>
      </div>
    }
  </div>

  <div class="td-wb-notification-toast__actions">
    <button class="td-wb-notification-toast__button"
            tdWbIconButton
            tdWbIconButtonBackground="clear-grey"
            tdWbIconButtonSize="extra-small"
      [attr.aria-label]="'tdWb.orderNotificationsToast.CLOSE_ARIA' | translate"
      (click)="close()">
      <td-wb-icon iconId="close--small" size="12" />
    </button>
    @if (!isExcessMessage()) {
      <button class="td-wb-notification-toast__button"
              tdWbIconButton
              tdWbIconButtonBackground="clear-grey"
              tdWbIconButtonSize="extra-small"
              tdWbHref="link_preferences_notifications"
              [attr.aria-label]="'tdWb.orderNotificationsToast.PREFERENCES_ARIA' | translate">
        <td-wb-icon iconId="cog" size="12" />
      </button>
    }
  </div>
</div>


<ng-template #orderTemplate>
  @if (!isMLO()) {
    <div
      class="td-wb-notification-toast__info">
      <div class="td-wb-notification-toast__price">
        @if (toast().isRejected) {
          <span class="td-wb-notification-toast__text-red" translate="tdWb.orderNotificationsToast.REJECTED"></span>&nbsp;
        }
        <ng-container *ngTemplateOutlet="orderItemTemplate; context:{ leg: toast() }" />
        <span class="td-wb-notification-toast_at-symbol"> &#64; </span>
        @if (toast().price) {
          <span [innerText]="toast().price | tdWbCurrency: {'format': 'c4-2'}"></span>
        }
        @if (toast().priceType) {
          <span [translate]="'tdWb.orderNotificationsToast.PRICE_' + toast().priceType"></span>
        }
      </div>
      <div>
        <span [innerText]="toast().accountNumber"></span><span> - </span>
        <span [innerText]="toast().accountCurrency"></span>&nbsp;<span [innerText]="toast().accountTypeDescription"></span>
      </div>
    </div>
  } @else {
    <div>
      <div>
        @if (toast().isRejected) {
          <span class="td-wb-notification-toast__text-red" translate="tdWb.orderNotificationsToast.REJECTED"></span>&nbsp;
        }
        <div class="td-wb-notification-toast__legs">
          <div>
            @for (item of toast().items; track item) {
              <div>
                <ng-container *ngTemplateOutlet="orderItemTemplate; context:{ leg: item }" />
              </div>
            }
          </div>
          @if (!toast().isRejected) {
            <div class="td-wb-notification-toast__legs-price--mlo">
              @if (toast().priceType || toast().price) {
                <span
                class="td-wb-notification-toast__at-symbol"> &#64; </span>
              }
              @if (toast().price) {
                <span
                [innerText]="getMLOPrice(toast().price) | tdWbCurrency: {'format': 'c4-2'}"></span>
              }
              @if (toast().priceType) {
                <span
                  class="td-wb-notification-toast__price-type"
                  [translate]="'tdWb.orderNotificationsToast.PRICE_' + toast().priceType">
                </span>
              }
            </div>
          }
        </div>
      </div>
      <div>
        <span [innerText]="toast().accountNumber"></span><span> - </span>
        <span [innerText]="toast().accountCurrency"></span>&nbsp;<span [innerText]="toast().accountTypeDescription"></span>
      </div>
    </div>
  }
</ng-template>


<ng-template #orderItemTemplate let-item="leg">
  <span [class]="'td-wb-notification-toast__text-green ' + getColourHighlight(item.action)"
        [translate]="'tdWb.orderNotificationsToast.' + item.action"></span>
  <span class="td-wb-notification-toast__quantity" [innerText]="toast().isRejected && item.dollarAmt ? (item.dollarAmt | tdWbCurrency) : item.quantity"></span>
  <span [innerText]="item.symbol"></span>
</ng-template>

<!-- remove the following code when the MLO Notification feature is ready-->

<ng-template #oldOrderTemplate>
  @if (toast().isComplex === false) {
    <div>
      <div>
        @if (toast().isRejected) {
          <span class="td-wb-notification-toast__text-red" translate="tdWb.orderNotificationsToast.REJECTED"></span>&nbsp;
        }
        <span [class]="'td-wb-notification-toast__text-green ' + getColourHighlight(toast().action)"
              [translate]="'tdWb.orderNotificationsToast.' + toast().action"></span>&nbsp;
        <span [innerText]="toast().quantity"></span>&nbsp;<span [innerText]="toast().symbol"></span>
        <span> &#64; </span>
        @if (toast().price) {
          <span [innerText]="toast().price | tdWbCurrency: {'format': 'c4-2'}"></span>
        }
        @if (toast().priceType) {
          <span [translate]="'tdWb.orderNotificationsToast.PRICE_' + toast().priceType"></span>
        }
      </div>
      <div>
        <span [innerText]="toast().accountNumber"></span><span> - </span>
        <span [innerText]="toast().accountCurrency"></span>&nbsp;<span [innerText]="toast().accountTypeDescription"></span>
      </div>
    </div>
  } @else {
    <div>
      @if (!isMLO()) {
        <div>
          <span translate="tdWb.orderNotificationsToast.COMPLEX_STATUS"></span>
          <span translate="tdWb.orderNotificationsToast.COMPLEX_GENERIC"></span>
          @if (isFTO()) {
            <span translate="tdWb.orderNotificationsToast.FTO_GENERIC"></span>
          }
          @if (isOTA()) {
            <span translate="tdWb.orderNotificationsToast.OTA_GENERIC"></span>
          }
          @if (isOCO()) {
            <span translate="tdWb.orderNotificationsToast.OCO_GENERIC"></span>
          }
          <span translate="tdWb.orderNotificationsToast.COMPLEX_GENERIC_CHANGED"></span>
        </div>
      } @else {
        @if (toast().isRejected) {
          <span class="td-wb-notification-toast__text-red" translate="tdWb.orderNotificationsToast.REJECTED"></span>&nbsp;
        }
        <span translate="tdWb.orderNotificationsToast.COMPLEX_GENERIC"></span>
        <span translate="tdWb.orderNotificationsToast.MLO_GENERIC"></span>
        <span [innerText]="toast().symbol"></span>
        @if (!toast().isRejected) {
          <span translate="tdWb.orderNotificationsToast.COMPLEX_GENERIC_FILLED"></span>
        }
      }
      <div>
        <span [innerText]="toast().accountNumber"></span>
        <span> - </span>
        <a class="td-wb-link" tdWbHref="link_order_status" [tdWbHrefParams]="{ clearAllFilters: true }" [tdWbHrefOptions]="{reload: true}">
          <span translate="tdWb.orderNotificationsToast.VIEW_ORDER_STATUS"></span>
        </a>
      </div>
    </div>
  }
</ng-template>


